<template>
  <div class="appendices">
    <h1 id="appendices">APPENDICES</h1>
    <table class="indicator-1">
      <tbody>
        <tr>
          <td rowspan="2" colspan="2">
            Indicator 1: <b>Test Episodes (thousands)</b>
          </td>
          <td v-for="(year, index) in years([1.1])" class="right-aligned">
            {{years([1.1])[index-1] !== year ? year : ''}}
          </td>
        </tr>
        <tr>
          <td v-for="(quarter, index) in quarters([1.1])" class="right-aligned">
            {{quarter}}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            {{rows([1.1])[0].name}}
          </td>
          <td v-for="(row, index) in rows([1.1])[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
        <tr>
          <td rowspan="3">
            Gender
          </td>
          <td>
            {{rows([1.2], 'Female')[0].name}}
          </td>
          <td v-for="row in rows([1.2], 'Female')[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([1.2], 'Male')[0].name}}
          </td>
          <td v-for="row in rows([1.2], 'Male')[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([1.2], 'Other')[0].name}}
          </td>
          <td v-for="row in rows([1.2], 'Other')[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
        <tr>
          <td rowspan="4">
            Age
          </td>
          <td>
            {{rows([1.3], '< 30')[0].name}}
          </td>
          <td v-for="row in rows([1.3], '< 30')[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([1.3], '30–39')[0].name}}
          </td>
          <td v-for="row in rows([1.3], '30–39')[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([1.3], '40–49')[0].name}}
          </td>
          <td v-for="row in rows([1.3], '40–49')[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([1.3], '≥ 50')[0].name}}
          </td>
          <td v-for="row in rows([1.3], '≥ 50')[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            POC Tests
          </td>
          <td v-for="row in rows([1.4])[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
        <template v-for="hsda in healthAuthorities[ha].hsda">
          <tr>
            <td colspan="2">
              {{hsda.name || hsda}}
            </td>
            <td v-for="row in rows([1.5], hsda.name || hsda)[0].data" class="right-aligned">
              {{row}}
            </td>
          </tr>
          <tr>
            <td colspan="2" class="left-padded">
              Female
            </td>
            <td v-for="row in rows([1.6], hsda.name || hsda)[0].data" class="right-aligned">
              {{row}}
            </td>
          </tr>
          <tr>
            <td colspan="2" class="left-padded">
              Male
            </td>
            <td v-for="row in rows([1.7], hsda.name || hsda)[0].data" class="right-aligned">
              {{row}}
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <table class="indicator-2">
      <tbody>
        <tr>
          <td colspan="2">
            Indicator 2: <b>Rate of HIV Testing per 100,000</b>
          </td>
          <td v-for="year in years(2.1)" class="right-aligned">
            {{year}}
          </td>
        </tr>
        <tr v-for="serie in rows([2.1])">
          <td colspan="2">
            {{serie.name}}
          </td>
          <td v-for="col in rows([2.1], serie.name)[0].data" class="right-aligned">
            {{col}}
          </td>
        </tr>
        <tr>
          <td rowspan="2">
            Gender
          </td>
          <td>
            {{rows([2.2], 'Female')[0].name}}
          </td>
          <td v-for="row in rows([2.2], 'Female')[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([2.2], 'Male')[0].name}}
          </td>
          <td v-for="row in rows([2.2], 'Male')[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
        <tr>
          <td rowspan="4">
            Age
          </td>
          <td>
            {{rows([2.3], '< 30')[0].name}}
          </td>
          <td v-for="row in rows([2.3], '< 30')[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([2.3], '30–39')[0].name}}
          </td>
          <td v-for="row in rows([2.3], '30–39')[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([2.3], '40–49')[0].name}}
          </td>
          <td v-for="row in rows([2.3], '40–49')[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([2.3], '≥ 50')[0].name}}
          </td>
          <td v-for="row in rows([2.3], '≥ 50')[0].data" class="right-aligned">
            {{row}}
          </td>
        </tr>
      </tbody>
    </table>

    <table class="indicator-3">
      <tbody>
        <tr>
          <td rowspan="2" colspan="2">
            Indicator 3: <b>New HIV Diagnoses</b>
          </td>
          <td v-for="(year, index) in years([3.1])" class="right-aligned">
            {{years([3.1])[index-1] !== year ? year : ''}}
          </td>
        </tr>
        <tr>
          <td v-for="(quarter, index) in quarters([3.1])" class="right-aligned">
            {{quarter}}
          </td>
        </tr>
        <tr>
          <td rowspan="2">
            {{healthAuthorities[ha].name}}
          </td>
          <td>
            By Client Residence
          </td>
          <td v-for="(row, index) in rows([3.1], healthAuthorities[ha].name)[0].data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr style="font-style: italic;">
          <td>
            By Provider Address
          </td>
          <td v-for="(row, index) in rows([3.1], 'By Provider Address')[0].data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr>
          <td rowspan="2">
            Gender
          </td>
          <td>
            {{rows([3.2], 'Female')[0].name}}
          </td>
          <td v-for="row in rows([3.2], 'Female')[0].data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([3.2], 'Male')[0].name}}
          </td>
          <td v-for="row in rows([3.2], 'Male')[0].data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr>
          <td rowspan="4">
            Age
          </td>
          <td>
            {{rows([3.3], '< 30')[0].name}}
          </td>
          <td v-for="row in rows([3.3], '< 30')[0].data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([3.3], '30–39')[0].name}}
          </td>
          <td v-for="row in rows([3.3], '30–39')[0].data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([3.3], '40–49')[0].name}}
          </td>
          <td v-for="row in rows([3.3], '40–49')[0].data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([3.3], '≥ 50')[0].name}}
          </td>
          <td v-for="row in rows([3.3], '≥ 50')[0].data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr>
          <td rowspan="5">
            Exposure
          </td>
          <td>
            {{rows([3.4], 'MSM')[0].name}}
          </td>
          <td v-for="row in rows([3.4], 'MSM')[0].data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([3.4], 'PWID')[0].name}}
          </td>
          <td v-for="row in rows([3.4], 'PWID')[0].data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([3.4], 'HET')[0].name}}
          </td>
          <td v-for="row in rows([3.4], 'HET')[0].data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([3.4], 'Other')[0].name}}
          </td>
          <td v-for="row in rows([3.4], 'Other')[0].data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr>
          <td>
            {{rows([3.4], 'NIR/Unknown')[0].name}}
          </td>
          <td v-for="row in rows([3.4], 'NIR/Unknown')[0].data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <template v-for="hsda in healthAuthorities[ha].hsda">
          <tr>
            <td rowspan="2">
              {{hsda.name || hsda}}
            </td>
            <td>
              By Client Residence
            </td>
            <td v-for="row in rows([3.5], hsda.name || hsda)[0].data" class="right-aligned">
              {{Number(row).toFixed(0)}}
            </td>
          </tr>
          <tr style="font-style: italic;">
            <td>
              By Provider Address
            </td>
            <td v-for="row in rows([3.5], 'By Provider Address', rows([3.5], hsda.name || hsda)[0].color)[0].data" class="right-aligned">
              {{Number(row).toFixed(0)}}
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <table class="indicator-4">
      <tbody>
        <tr>
          <td colspan="31">
            Indicator 4: <b>Stage of HIV Infection at Baseline</b>
          </td>
        </tr>
        <tr>
          <td>

          </td>
          <td colspan="5" class="center-aligned">
            {{healthAuthorities[ha].name}}
          </td>
          <td colspan="5" class="center-aligned">
            Female
          </td>
          <td colspan="5" class="center-aligned">
            Male
          </td>
          <td colspan="5" class="center-aligned">
            < 30 years
          </td>
          <td colspan="5" class="center-aligned">
            30-39 years
          </td>
          <td colspan="5" class="center-aligned">
            40-49 years
          </td>
        </tr>
        <tr>
          <td></td>
          <td v-for="year in years(4.1)" class="right-aligned">
            {{`\'${year.toString().slice(-2)}`}}
          </td>
          <td v-for="year in years(4.2)" class="right-aligned">
            {{`\'${year.toString().slice(-2)}`}}
          </td>
          <td v-for="year in years(4.3).slice(0, -5)" class="right-aligned">
            {{`\'${year.toString().slice(-2)}`}}
          </td>
        </tr>
        <template v-for="serie in rows([4.1])">
          <tr>
            <td>
              {{serie.name}}
            </td>
            <td v-for="row in rows([4.1], serie.name)[0].data" class="right-aligned">
              {{row}}
            </td>
            <td v-for="row in rows([4.3], serie.name)[0].data.slice(0, 15)" class="right-aligned">
              {{row}}
            </td>
          </tr>
        </template>

        <tr style="height: 40px;">
          <td class="bottom-aligned">

          </td>
          <td colspan="5" class="center-aligned bottom-aligned">
            ≥ 50 years
          </td>
          <td colspan="5" class="center-aligned bottom-aligned">
            MSM
          </td>
          <td colspan="5" class="center-aligned bottom-aligned">
            PWID
          </td>
          <td colspan="5" class="center-aligned bottom-aligned">
            Heterosexual
          </td>
          <td colspan="5" class="center-aligned bottom-aligned">
            Other Exposure
          </td>
          <td colspan="5" class="center-aligned bottom-aligned">
            NIR/Unknown
          </td>
        </tr>
        <tr>
          <td></td>
          <td v-for="year in years(4.1)" class="right-aligned">
            {{`\'${year.toString().slice(-2)}`}}
          </td>
          <td v-for="year in years(4.2)" class="right-aligned">
            {{`\'${year.toString().slice(-2)}`}}
          </td>
          <td v-for="year in years(4.3).slice(0, -5)" class="right-aligned">
            {{`\'${year.toString().slice(-2)}`}}
          </td>
        </tr>
        <template v-for="serie in rows([4.1])">
          <tr>
            <td>
              {{serie.name}}
            </td>
            <td v-for="row in rows([4.3], serie.name)[0].data.slice(-30)" class="right-aligned">
              {{row}}
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <table class="indicator-5">
      <tbody>
        <tr>
          <td colspan="3">
            Indicator 5: <b>HIV Cascade of Care</b>
          </td>
          <td class="right-aligned">
            Diagnosed
          </td>
          <td class="right-aligned">
            Linked
          </td>
          <td class="right-aligned">
            Retained
          </td>
          <td class="right-aligned">
            On ARVs
          </td>
          <td class="right-aligned">
            Adherent
          </td>
          <td class="right-aligned">
            Suppressed
          </td>
        </tr>
        <tr>
          <td colspan="3">
            {{healthAuthorities[ha].name}}
          </td>
          <td v-for="value in rows([5.1], 'Overall HA')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td rowspan="2">
            Gender
          </td>
          <td colspan="2">
            Men
          </td>
          <td v-for="value in rows([5.2], 'Men')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            Women
          </td>
          <td v-for="value in rows([5.2], 'Women')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td rowspan="4">
            Age Category
          </td>
          <td colspan="2">
            < 30
          </td>
          <td v-for="value in rows([5.3], '< 30')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            30–39
          </td>
          <td v-for="value in rows([5.3], '30–39')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            40–49
          </td>
          <td v-for="value in rows([5.3], '40–49')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            ≥ 50
          </td>
          <td v-for="value in rows([5.3], '≥ 50')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td rowspan="3">
            MSM Status
          </td>
          <td colspan="2">
            MSM
          </td>
          <td v-for="value in rows([5.4], 'MSM')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            Non-MSM
          </td>
          <td v-for="value in rows([5.4], 'Non-MSM')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            Unknown
          </td>
          <td v-for="value in rows([5.4], 'Unknown')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td rowspan="12">
            Age Category and MSM Status
          </td>
          <td rowspan="4">
            MSM
          </td>
          <td>
            < 30
          </td>
          <td v-for="value in rows([5.5], 'MSM:<30')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td>
            30-39
          </td>
          <td v-for="value in rows([5.5], 'MSM:30-39')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td>
            40-49
          </td>
          <td v-for="value in rows([5.5], 'MSM:40-49')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td>
            ≥ 50
          </td>
          <td v-for="value in rows([5.5], 'MSM:>=50')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td rowspan="4">
            Non-MSM
          </td>
          <td>
            < 30
          </td>
          <td v-for="value in rows([5.5], 'Non-MSM:<30')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td>
            30-39
          </td>
          <td v-for="value in rows([5.5], 'Non-MSM:30-39')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td>
            40-49
          </td>
          <td v-for="value in rows([5.5], 'Non-MSM:40-49')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td>
            ≥ 50
          </td>
          <td v-for="value in rows([5.5], 'Non-MSM:>=50')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td rowspan="4">
            Unknown
          </td>
          <td>
            < 30
          </td>
          <td v-for="value in rows([5.5], 'Unknown:<30')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td>
            30-39
          </td>
          <td v-for="value in rows([5.5], 'Unknown:30-39')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td>
            40-49
          </td>
          <td v-for="value in rows([5.5], 'Unknown:40-49')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td>
            ≥ 50
          </td>
          <td v-for="value in rows([5.5], 'Unknown:>=50')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td rowspan="3">
            PWID Status
          </td>
          <td colspan="2">
            PWID
          </td>
          <td v-for="value in rows([5.6], 'IDU')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            Non-PWID
          </td>
          <td v-for="value in rows([5.6], 'Non-IDU')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <tr>
          <td colspan="2">
            Unknown
          </td>
          <td v-for="value in rows([5.6], 'Unknown')" class="right-aligned">
            {{value}}
          </td>
        </tr>
        <template v-for="(hsda, index) in healthAuthorities[ha].hsda">
          <tr>
            <td v-if="index === 0" v-bind:rowspan="healthAuthorities[ha].hsda.length">
              {{ha === 'bc' ? 'Health Authority' : 'HSDA'}}
            </td>
            <td colspan="2">
              {{hsda.name || hsda}}
            </td>
            <td v-for="value in rows([5.7], hsda.name || hsda)" class="right-aligned">
              {{value}}
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <table class="indicator-6">
      <tbody>
        <tr>
          <td class="bottom-aligned" rowspan="2">
            Indicator 6: <b>Programmatic Compliance Score (PCS)</b>
          </td>
          <td v-for="(year, index) in years([6.1])" class="right-aligned">
            {{years([6.1])[index-1] !== year ? year : ''}}
          </td>
        </tr>
        <tr>
          <td v-for="(quarter, index) in quarters([6.1])" class="right-aligned">
            {{quarter}}
          </td>
        </tr>
        <template v-for="(row, index) in indicator6">
          <tr>
            <td>
              {{row.name}}
            </td>
            <td v-for="value in rows(row.figure, row.serie || row.name)[0].data" class="right-aligned">
              {{Number(value).toFixed(index <= 5 ? 1 : 0)}}{{index <= 5 ? '%' : ''}}
            </td>
          </tr>
        </template>

        <tr class="new-indicator">
          <td class="bottom-aligned" rowspan="2">
            Indicator 7: <b>New DTP ARV Participants</b>
          </td>
          <td v-for="(year, index) in years([7])" class="right-aligned bottom-aligned">
            {{years([7])[index-1] !== year ? year : ''}}
          </td>
        </tr>
        <tr>
          <td v-for="(quarter, index) in quarters([7])" class="right-aligned">
            {{quarter}}
          </td>
        </tr>
        <template v-for="(row, index) in indicator7">
          <tr>
            <td>
              {{row.name}}
            </td>
            <td v-for="value in rows([7], row.serie || row.name)[0].data" class="right-aligned">
              {{Number(value).toFixed(0)}}
            </td>
          </tr>
        </template>

        <tr class="new-indicator">
          <td class="bottom-aligned" rowspan="2">
            Indicator 8: <b>CD4 Cell Count Initiation for ARV-Naïve DTP Participants</b>
          </td>
          <td v-for="(year, index) in years([8])" class="right-aligned bottom-aligned">
            {{years([8])[index-1] !== year ? year : ''}}
          </td>
        </tr>
        <tr>
          <td v-for="(quarter, index) in quarters([8])" class="right-aligned">
            {{quarter}}
          </td>
        </tr>
        <template v-for="(row, index) in indicator8">
          <tr>
            <td>
              {{row.name}}
            </td>
            <td v-for="value in rows([8], row.serie || row.name)[0].data" class="right-aligned">
              {{Number(value).toFixed(0)}}
            </td>
          </tr>
        </template>

        <tr class="new-indicator">
          <td class="bottom-aligned" rowspan="2">
            Indicator 9: <b>Active and Inactive DTP Participants</b>
          </td>
          <td v-for="(year, index) in years([9])" class="right-aligned bottom-aligned">
            {{years([9])[index-1] !== year ? year : ''}}
          </td>
        </tr>
        <tr>
          <td v-for="(quarter, index) in quarters([9])" class="right-aligned">
            {{quarter}}
          </td>
        </tr>
        <template v-for="(row, index) in indicator9">
          <tr>
            <td>
              {{row.name}}
            </td>
            <td v-for="value in rows([9], row.serie || row.name)[0].data" class="right-aligned">
              {{Number(value).toFixed(0)}}
            </td>
          </tr>
        </template>

        <tr class="new-indicator">
          <td class="bottom-aligned" rowspan="2">
            Indicator 10: <b>Antiretroviral Adherence</b>
          </td>
          <td v-for="(year, index) in years([10])" class="right-aligned bottom-aligned">
            {{years([10])[index-1] !== year ? year : ''}}
          </td>
        </tr>
        <tr>
          <td v-for="(quarter, index) in quarters([10])" class="right-aligned">
            {{quarter}}
          </td>
        </tr>
        <template v-for="(row, index) in indicator10">
          <tr>
            <td>
              {{row.name}}
            </td>
            <td v-for="value in rows([10], row.serie || row.name)[0].data" class="right-aligned">
              {{Number(value).toFixed(0)}}
            </td>
          </tr>
        </template>

        <tr class="new-indicator">
          <td class="bottom-aligned" rowspan="2">
            Indicator 11: <b>Resistance Testing and Results</b>
          </td>
          <td v-for="(year, index) in years([11])" class="right-aligned bottom-aligned">
            {{years([11])[index-1] !== year ? year : ''}}
          </td>
        </tr>
        <tr>
          <td v-for="(quarter, index) in quarters([11])" class="right-aligned">
            {{quarter}}
          </td>
        </tr>
        <template v-for="(row, index) in indicator11">
          <tr>
            <td>
              {{row.name}}
            </td>
            <td v-for="value in rows([11], row.serie || row.name)[0].data" class="right-aligned">
              {{Number(value).toFixed(0)}}
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <table class="indicator-12">
      <tbody>
        <tr style="height: 40px;">
          <td colspan="2" class="bottom-aligned">
            Indicator 12: <b>AIDS-Defining Illness</b>
          </td>
          <td v-for="year in years(12)" class="right-aligned bottom-aligned">
            {{year}}
          </td>
        </tr>
        <tr>
          <td rowspan="2">
            CD4 < 200 at ART initiation
          </td>
          <td>
            Cases
          </td>
          <td v-for="row in rows([12]).find(function(e){return e.table.title === 'CD4<200 at ART Initiation (CASES)'}).data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr style="font-style: italic">
          <td>
            Rate per 100,000
          </td>
          <td v-for="row in rows([12]).find(function(e){return e.table.title === 'CD4<200 at ART Initiation (PER 100K)'}).data" class="right-aligned">
            {{Number(row).toFixed(1)}}
          </td>
        </tr>
        <tr>
          <td rowspan="2">
            AIDS Cases (DTP Reports)
          </td>
          <td>
            Cases
          </td>
          <td v-for="row in rows([12]).find(function(e){return e.table.title === 'AIDS: DTP Reports (CASES)'}).data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr style="font-style: italic">
          <td>
            Rate per 100,000
          </td>
          <td v-for="row in rows([12]).find(function(e){return e.table.title === 'AIDS: DTP Reports (PER 100K)'}).data" class="right-aligned">
            {{Number(row).toFixed(1)}}
          </td>
        </tr>
        <tr>
          <td rowspan="2">
            AIDS Cases (BCCDC Reports)
          </td>
          <td>
            Cases
          </td>
          <td v-for="row in rows([12]).find(function(e){return e.table.title === 'AIDS: BCCDC Reports (CASES)'}).data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr>
          <td style="font-style: italic">
            Rate per 100,000
          </td>
          <td v-for="row in rows([12]).find(function(e){return e.table.title === 'AIDS: BCCDC Reports (PER 100K)'}).data" class="right-aligned">
            {{Number(row).toFixed(1)}}
          </td>
        </tr>
      </tbody>
    </table>

    <table class="indicator-13" style="margin-bottom: 0px;">
      <tbody>
        <tr style="height: 40px;">
          <td class="bottom-aligned">
            Indicator 13: <b>HIV-Related Mortality</b>
          </td>
          <td v-for="year in years(13)" class="right-aligned bottom-aligned">
            {{year}}
          </td>
        </tr>
        <tr>
          <td>
            British Columbia
          </td>
          <td v-for="row in rows([13]).find(function(e){return e.table.title === 'HIV-Related Deaths'}).data" class="right-aligned">
            {{Number(row).toFixed(0)}}
          </td>
        </tr>
        <tr>
          <td>
            Per 100 HIV+ Population
          </td>
          <td v-for="row in rows([13]).find(function(e){return e.table.title === 'Per 100 HIV+ Population'}).data" class="right-aligned">
            {{Number(row).toFixed(2)}}
          </td>
        </tr>
        <tr>
          <td>
            Per 100,000 Population
          </td>
          <td v-for="row in rows([13]).find(function(e){return e.table.title === 'Per 100,000 Population'}).data" class="right-aligned">
            {{Number(row).toFixed(2)}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { healthAuthorities } from './../../cli/constants';

  export default {
    data() {
      return {
        healthAuthorities,
        ha: this.$route.params.ha,
        indicator6: [
          {
            name: '< 3 CD4 Tests',
            figure: [6.1],
            serie: '<3 CD4 Tests',
          },
          {
            name: '< 3 Viral Load Tests',
            figure: [6.1],
            serie: '<3 Viral Load Tests',
          },
          {
            name: 'No Baseline Genotype',
            figure: [6.1],
          },
          {
            name: 'Baseline CD4 < 200 cells/µL',
            figure: [6.1],
            serie: 'Baseline CD4 <200/µL',
          },
          {
            name: 'Non-Recommended ART',
            figure: [6.1],
          },
          {
            name: 'Non Viral Suppression at 9 Mo.',
            figure: [6.1],
          },
          {
            name: 'PCS Score: 0',
            figure: [6.2],
            serie: '0',
          },
          {
            name: 'PCS Score: 1',
            figure: [6.2],
            serie: '1',
          },
          {
            name: 'PCS Score: 2',
            figure: [6.2],
            serie: '2',
          },
          {
            name: 'PCS Score: 3',
            figure: [6.2],
            serie: '3',
          },
          {
            name: 'PCS Score: 4 or more',
            figure: [6.2],
            serie: '≥ 4',
          },
          {
            name: 'Total (n=)',
            figure: [6.2],
            serie: 'n=',
          },
        ],
        indicator7: [
          {
            name: 'First Starts'
          },
          {
            name: 'Experienced Starts'
          }
        ],
        indicator8: [
          {
            name: 'CD4 ≥ 500',
            serie: '≥ 500 cells/µL',
          },
          {
            name: 'CD4 350-499',
            serie: '350–499',
          },
          {
            name: 'CD4 200-349',
            serie: '200–349',
          },
          {
            name: 'CD4 50-199',
            serie: '50–199',
          },
          {
            name: 'CD4 < 50',
            serie: '< 50 cells/µL',
          },
          {
            name: 'Total (n=)',
            serie: 'n=',
          },
          {
            name: 'CD4 Median',
            serie: 'Median',
          },
        ],
        indicator9: [
          {
            name: 'Active DTP Participants',
            serie: 'Active',
          },
          {
            name: 'Inactive DTP Participants',
            serie: 'Inactive',
          }
        ],
        indicator10: [
          {
            name: '≥ 95%',
          },
          {
            serie: '80% to<br>< 95%',
            name: '80% to < 95%'
          },
          {
            serie: '40% to<br>< 80%',
            name: '40% to < 80%'
          },
          {
            name: '< 40%',
          },
          {
            name: 'Total (n=)',
            serie: 'n=',
          }
        ],
        indicator11: [
          {
            name: 'Suppressed',
          },
          {
            name: 'Wild Type',
          },
          {
            name: 'Never Genotyped'
          }
          ,
          {
            name: '1-Class'
          }
          ,
          {
            name: '2-Class'
          }
          ,
          {
            name: '3-Class'
          }
          ,
          {
            name: '4-Class'
          },
          {
            name: 'Total (n=)',
            serie: 'n='
          }
        ],
      }
    },
    methods: {
      years: function(figure) {
          const json = require(`./../../../temp/json/figure_${this.$route.params.ha}_${figure.toString().replace('.', '_')}.json`).instr;
          if (figure >= 4.1 && figure <= 4.4) {
            return json.dataTable.header;
          } else {
            return json.xAxis[json.xAxis[1] ? 1 : 0].categories;
          }
      },
      quarters: function(figure) {
        return require(`./../../../temp/json/figure_${this.$route.params.ha}_${figure.toString().replace('.', '_')}.json`).instr.xAxis[0].categories;
      },
      rows: function(figures, serieName, color) {
        let rows = [];
        if ([4.1, 4.2, 4.3, 4.4].includes(figures[0])) {
          for (const figure of figures) {
            const json = require(`./../../../temp/json/figure_${this.$route.params.ha}_${figure.toString().replace('.', '_')}.json`).instr;
            rows = json.dataTable.rows.filter(function(e){
              return (typeof serieName === 'string' ? e.name === serieName : e.name === e.name);
            });
          }
        } else if ([5.1, 5.2, 5.3, 5.4, 5.5, 5.6, 5.7].includes(figures[0])){
          const json = require(`./../../../temp/json/figure_${this.$route.params.ha}_${figures[0].toString().replace('.', '_')}.json`).instr;
          rows = json.dataTable[serieName];
        } else {
          for (const figure of figures) {
            const json = require(`./../../../temp/json/figure_${this.$route.params.ha}_${figure.toString().replace('.', '_')}.json`).instr;
            for (const serie of json.series.filter(function(e){
              return e.name === (typeof serieName === 'string' ? serieName : e.name)
            })) {
              const data = [];
              for (const val of serie.data) {
                if (typeof val === 'number') {
                  data.push(val.toFixed((figures[0] === 13 ? 2 : 1)));
                } else {
                  data.push(val.y.toFixed(1));
                }
              }
              rows.push({
                name: serie.name,
                data: data,
                color: serie.color,
                table: serie.table || {}
              });
            }
          }
          rows.sort(function(a, b){
            const nameA = a.name.toUpperCase(); // ignore upper and lowercase
            const nameB = b.name.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }

            // names must be equal
            return 0;
          });

          if (figures.includes(3.4)) {
            for (const row of rows) {
              row.data = row.data.slice(2);
            }
          }

          if (typeof color === 'string') {
            rows = rows.filter(function(e){
              return e.color === color;
            });
          }
        }
        return rows;
      }
    },
    mounted() {
      /**
       * @author Rafael Trevisan <rtrevisan@cfenet.ubc.ca>
       * @description Indicator 4.4 has a different time frame than other 4.*
       */
      // commented out on 15-Aug-2018 as indicator has now the same time frame.
      // let y = 12;
      // for (let i = 7; i <= 31; i++) {
      //   $(`#app > div > div.appendices > table.indicator-4 > tbody > tr:nth-child(12) > td:nth-child(${i})`).text(`'${y}`);
      //   y = y + 1;
      //   if (y === 17) {
      //     y = 12;
      //   }
      // }

      // if (this.$route.params.ha !== 'bc') {
      //   const highlight = {
      //     'fha': [17, 20],
      //     'iha': [17, 20, 23],
      //     'nha': [17, 20],
      //     'vcha': [17, 20],
      //     'viha': [17, 20]
      //   };

      //   for (const trIndex of highlight[this.$route.params.ha]) {
      //     $(`#app > div > div.appendices > table.indicator-1 > tbody > tr:nth-child(${trIndex})`).css({
      //       'background-color': 'rgba(255, 255, 0, 0.5)'
      //     });
      //   }

      // }
      
      /**
       * @author Rafael Trevisan <rtrevisan@cfenet.ubc.ca>
       * @description Using JQuery to apply suppression on numbers between 1 and 4 *after* tables been rendered.
       *  29-AUG-2017: Rolando has decided to not suppress any data anymore until further notice
       */
      // $('table.indicator-3 td,\
      //    table.indicator-4 > tbody > tr:nth-child(n+4):nth-child(-n+9) > td,\
      //    table.indicator-4 > tbody > tr:nth-child(n+13):nth-child(-n+18) > td,\
      //    table.indicator-5 td,\
      //    table.indicator-6 td,\
      //    table.indicator-12 > tbody > tr:nth-child(2) > td,\
      //    table.indicator-12 > tbody > tr:nth-child(4) > td,\
      //    table.indicator-12 > tbody > tr:nth-child(6) > td').each(function( index, element ) {
      //   const num = $(element).text().trim();
      //   if (num !== '' && !isNaN(num)){
      //     if (num >= 0 && num < 5) {
      //       $(element).text('*');
      //       $(element).attr('title', 'Suppressed for privacy reason');
      //       $(element).css('font-size', '20px');
      //       $(element).css('line-height', '1');
      //     }
      //   }
      // });

      /**
       * for each column in table indicator-6
       * get how many "<5" each column has from row 9 to 13 and put into len
       * if len === 1 then mask the whole column
       */
      function mask(indicator, rowStart, rowEnd, colStart, colEnd, maskTo) {
        for (let col = colStart; col < colEnd; col++) {
          const len = $(`table.${indicator} > tbody > tr:nth-child(n+${rowStart}):nth-child(-n+${rowEnd}) > td:nth-child(${col})`).filter(function(){
                        return $(this).text() === '*';
                      }).length;
          if (len === 1) {
            $(`table.${indicator} > tbody > tr:nth-child(n+${rowStart}):nth-child(-n+${rowEnd}) > td:nth-child(${col})`).html(maskTo || '<span style="font-size: 20px; line-height: 1;" title="Hidden for privacy reason">*</span>');
          }
        }
      }

      // indicator-4 part a
      // mask('indicator-4', 4, 9, 2, 32);
      // indicator-4 part b
      // mask('indicator-4', 13, 18, 2, 32);
      // indicator-6
      // mask('indicator-6', 9, 13, 2, 10);
      // indicator-8
      // mask('indicator-6', 19, 23, 2, 10);
      // indicator-10
      // mask('indicator-6', 30, 33, 2, 10);
      // indicator-11
      // mask('indicator-6', 36, 42, 2, 10);
    }
  }
</script>

<style scoped>
  table {
    font-size: 0.85em;
    width: 100%;
    margin-bottom: 40px;
    border-spacing: 0px;
  }

  .indicator-1 td,
  .indicator-2 td,
  .indicator-3 td,
  .indicator-5 td
   {
    vertical-align: top;
  }

  .left-padded{
    padding-left: 20px;
  }

  table.indicator-1 > tbody > tr:nth-child(3) > td,
  table.indicator-2 > tbody > tr:nth-child(2) > td,
  table.indicator-3 > tbody > tr:nth-child(3) > td,
  table.indicator-5 > tbody > tr:nth-child(2) > td,
  table.indicator-6 > tbody > tr:nth-child(3) > td,
  table.indicator-6 > tbody > tr:nth-child(17) > td,
  table.indicator-6 > tbody > tr:nth-child(21) > td,
  table.indicator-6 > tbody > tr:nth-child(30) > td,
  table.indicator-6 > tbody > tr:nth-child(34) > td,
  table.indicator-6 > tbody > tr:nth-child(41) > td,
  table.indicator-12 > tbody > tr:nth-child(2) > td,
  table.indicator-13 > tbody > tr:nth-child(2) > td {
    border-top: 1px solid black;
  }

  table.indicator-4 > tbody > tr:nth-child(n+3):nth-child(-n+10) > td:nth-child(1),
  table.indicator-4 > tbody > tr:nth-child(n+3):nth-child(-n+10) > td:nth-child(6),
  table.indicator-4 > tbody > tr:nth-child(n+3):nth-child(-n+10) > td:nth-child(11),
  table.indicator-4 > tbody > tr:nth-child(n+3):nth-child(-n+10) > td:nth-child(16),
  table.indicator-4 > tbody > tr:nth-child(n+3):nth-child(-n+10) > td:nth-child(21),
  table.indicator-4 > tbody > tr:nth-child(n+3):nth-child(-n+10) > td:nth-child(26),

  table.indicator-4 > tbody > tr:nth-child(n+12):nth-child(-n+19) > td:nth-child(1),
  table.indicator-4 > tbody > tr:nth-child(n+12):nth-child(-n+19) > td:nth-child(6),
  table.indicator-4 > tbody > tr:nth-child(n+12):nth-child(-n+19) > td:nth-child(11),
  table.indicator-4 > tbody > tr:nth-child(n+12):nth-child(-n+19) > td:nth-child(16),
  table.indicator-4 > tbody > tr:nth-child(n+12):nth-child(-n+19) > td:nth-child(21),
  table.indicator-4 > tbody > tr:nth-child(n+12):nth-child(-n+19) > td:nth-child(26) {
    border-right: 1px solid black;
  }

  table.indicator-4 td {
    padding: 4px;
    padding-top: 1px;
    padding-bottom: 1px;
  }

  table.indicator-4 > tbody > tr:nth-child(10),
  table.indicator-4 > tbody > tr:nth-child(19),
  table.indicator-6 > tbody > tr:nth-child(14),
  table.indicator-6 > tbody > tr:nth-child(26),
  table.indicator-6 > tbody > tr:nth-child(38),
  table.indicator-6 > tbody > tr:nth-child(48) {
    font-weight: bold;
  }

  tr.new-indicator {
    height: 80px;
  }
</style>



// WEBPACK FOOTER //
// Appendices.vue?36a1c4e1